/**
 * Limits and Constraints Configuration
 *
 * This file contains all application limits including file upload sizes,
 * API fetch limits, and other constraints.
 */

export const FILE_SIZE_LIMITS = {
  /**
   * Maximum file size for thumbnail uploads (in bytes)
   * 8MB - Suitable for high-quality images
   */
  THUMBNAIL_MAX: 8 * 1024 * 1024,

  /**
   * Maximum file size for video uploads (in bytes)
   * 4GB - Large enough for HD videos but prevents abuse
   */
  VIDEO_MAX: 4 * 1024 * 1024 * 1024,

  /**
   * Maximum size of an event-import csv (in bytes)
   * 2MB - must stay in sync with eventImportMaxBytes in the backend
   */
  EVENT_IMPORT_CSV_MAX: 2 * 1024 * 1024,
} as const;

/**
 * Helper function to format file size limits for display
 * @param bytes File size in bytes
 * @returns Formatted string like "5 MB" or "2 GB"
 */
export function formatFileSize(bytes: number): string {
  if (bytes >= 1024 * 1024 * 1024) {
    return `${(bytes / (1024 * 1024 * 1024)).toFixed(0)} GB`;
  }
  if (bytes >= 1024 * 1024) {
    return `${(bytes / (1024 * 1024)).toFixed(0)} MB`;
  }
  if (bytes >= 1024) {
    return `${(bytes / 1024).toFixed(0)} KB`;
  }
  return `${bytes} Bytes`;
}
